import { useMemo } from 'react';
import { GlobalContextProvider } from '~/Features/Configuration/GlobalContextProvider';

export const useFrontendSettings = () => useMemo(() => GlobalContextProvider.getFrontendSettings(), []);
